// extracted by mini-css-extract-plugin
export default {"actionsPopUp":"ActionPopUp_actionsPopUp__EIWzh","actionsPopUp__header":"ActionPopUp_actionsPopUp__header__933Bm","actionsPopUp__body":"ActionPopUp_actionsPopUp__body__0dIQs"};